import { Icon } from "icons";
import { useTranslation } from "react-i18next";

import { LabelPickerTriggerDot } from "./LabelPickerTriggerDot";

const TRIGGER_DOT_LIMIT = 3;

export function LabelPickerTriggerLabels(props: {
  labels: { id: string; name: string; color: string }[];
}) {
  const { t } = useTranslation();

  if (props.labels.length === 0) {
    return (
      <>
        <Icon name="tabler-tag" className="size-3.5 shrink-0" aria-hidden />
        <span>{t("labelPicker.labels")}</span>
      </>
    );
  }

  return (
    <>
      <span aria-hidden className="flex shrink-0 items-center">
        {props.labels.slice(0, TRIGGER_DOT_LIMIT).map((label, index) => {
          return (
            <LabelPickerTriggerDot
              key={label.id}
              color={label.color}
              overlaps={index > 0}
            />
          );
        })}
      </span>
      <span className="truncate">
        {props.labels.length === 1
          ? props.labels[0]!.name
          : t("labelPicker.labelCount", { count: props.labels.length })}
      </span>
    </>
  );
}
